














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { bus } from '../main';
import CardMove from './CardMove.vue';
import EffectIcon from './EffectIcon.vue';
import { Technology, Card, Innovation } from '../model/technology';
import { state } from '../model/store';

@Component({
  components: {
    CardMove,
    EffectIcon,
  },
})
export default class TechCard extends Vue {
  @Prop() private card!: Card;

  @Prop() private highlight!: boolean;

  get text(): string {
    if (this.card instanceof Technology) {
      return ['Potential innovations:', ...this.card.innovations.map((i) => i.name)].join('\n- ');
    }
    if (this.card instanceof Innovation) {
      return ['Innovation for...', ...this.card.technologies.map((i) => i.name)].join('\n- ');
    }
    return '';
  }

  get id(): string {
    return this.card.id;
  }

  get isTechnology() {
    return this.card instanceof Technology;
  }

  get isInnovation() {
    return this.card instanceof Innovation;
  }

  onClick() {
    state.selectCard(this.card);
  }

  onMouseOver() {
    bus.$emit('hover-card', this.card, true);
  }

  onMouseLeave() {
    bus.$emit('hover-card', this.card, false);
  }
}
